import { render, staticRenderFns } from "./StatisticsWdTurnoverWdFilters.vue?vue&type=template&id=90abe51e&"
import script from "./StatisticsWdTurnoverWdFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnoverWdFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports